// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/nucleo.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/nucleo.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/nucleo.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/nucleo.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --------------------------------

Nucleo Outline Web Font - nucleoapp.com/
License - nucleoapp.com/license/
Created using IcoMoon - icomoon.io

-------------------------------- */

@font-face {
  font-family: 'Nucleo';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

/*------------------------
	base class definition
-------------------------*/

.tim-icons {
  display: inline-block;
  font: normal normal normal 1em/1 'Nucleo';
  vertical-align: middle;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.font-icon-detail {
  text-align: center;
  padding: 45px 0 30px;
  border: 1px solid #e44cc4;
  border-radius: .1875rem;
  margin: 15px 0;
  min-height: 168px;
}

.font-icon-detail i {
  color: #FFFFFF;
  font-size: 1.5em;
}

.font-icon-detail p {
  color: #e44cc4 !important;
  margin-top: 30px;
  padding: 0 10px;
  font-size: .7142em;
}

/*------------------------
  change icon size
-------------------------*/

.tim-icons-sm {
  font-size: 0.8em;
}

.tim-icons-lg {
  font-size: 1.2em;
}

/* absolute units */

.tim-icons-16 {
  font-size: 16px;
}

.tim-icons-32 {
  font-size: 32px;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/

.tim-icons-bg-square,
.tim-icons-bg-circle {
  padding: 0.35em;
}

.tim-icons-bg-circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/

/*------------------------
  spinning icons
-------------------------*/

.tim-icons-is-spinning {
  animation: tim-icons-spin 2s infinite linear;
}

@keyframes tim-icons-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/*------------------------
  rotated/flipped icons
-------------------------*/

/*------------------------
	icons
-------------------------*/

.icon-alert-circle-exc::before {
  content: "\\ea02";
}

.icon-align-center::before {
  content: "\\ea03";
}

.icon-align-left-2::before {
  content: "\\ea04";
}

.icon-app::before {
  content: "\\ea05";
}

.icon-atom::before {
  content: "\\ea06";
}

.icon-attach-87::before {
  content: "\\ea07";
}

.icon-badge::before {
  content: "\\ea08";
}

.icon-bag-16::before {
  content: "\\ea09";
}

.icon-bank::before {
  content: "\\ea0a";
}

.icon-basket-simple::before {
  content: "\\ea0b";
}

.icon-bell-55::before {
  content: "\\ea0c";
}

.icon-bold::before {
  content: "\\ea0d";
}

.icon-book-bookmark::before {
  content: "\\ea0e";
}

.icon-bulb-63::before {
  content: "\\ea0f";
}

.icon-bullet-list-67::before {
  content: "\\ea10";
}

.icon-bus-front-12::before {
  content: "\\ea11";
}

.icon-button-pause::before {
  content: "\\ea12";
}

.icon-button-power::before {
  content: "\\ea13";
}

.icon-calendar-60::before {
  content: "\\ea14";
}

.icon-camera-18::before {
  content: "\\ea15";
}

.icon-caps-small::before {
  content: "\\ea16";
}

.icon-cart::before {
  content: "\\ea17";
}

.icon-chart-bar-32::before {
  content: "\\ea18";
}

.icon-chart-pie-36::before {
  content: "\\ea19";
}

.icon-chat-33::before {
  content: "\\ea1a";
}

.icon-check-2::before {
  content: "\\ea1b";
}

.icon-cloud-download-93::before {
  content: "\\ea1c";
}

.icon-cloud-upload-94::before {
  content: "\\ea1d";
}

.icon-coins::before {
  content: "\\ea1e";
}

.icon-compass-05::before {
  content: "\\ea1f";
}

.icon-controller::before {
  content: "\\ea20";
}

.icon-credit-card::before {
  content: "\\ea21";
}

.icon-delivery-fast::before {
  content: "\\ea22";
}

.icon-double-left::before {
  content: "\\ea23";
}

.icon-double-right::before {
  content: "\\ea24";
}

.icon-email-85::before {
  content: "\\ea25";
}

.icon-gift-2::before {
  content: "\\ea26";
}

.icon-globe-2::before {
  content: "\\ea27";
}

.icon-headphones::before {
  content: "\\ea28";
}

.icon-heart-2::before {
  content: "\\ea29";
}

.icon-html5::before {
  content: "\\ea2a";
}

.icon-image-02::before {
  content: "\\ea2b";
}

.icon-istanbul::before {
  content: "\\ea2c";
}

.icon-key-25::before {
  content: "\\ea2d";
}

.icon-laptop::before {
  content: "\\ea2e";
}

.icon-light-3::before {
  content: "\\ea2f";
}

.icon-link-72::before {
  content: "\\ea30";
}

.icon-lock-circle::before {
  content: "\\ea31";
}

.icon-map-big::before {
  content: "\\ea32";
}

.icon-minimal-down::before {
  content: "\\ea33";
}

.icon-minimal-left::before {
  content: "\\ea34";
}

.icon-minimal-right::before {
  content: "\\ea35";
}

.icon-minimal-up::before {
  content: "\\ea36";
}

.icon-mobile::before {
  content: "\\ea37";
}

.icon-molecule-40::before {
  content: "\\ea38";
}

.icon-money-coins::before {
  content: "\\ea39";
}

.icon-notes::before {
  content: "\\ea3a";
}

.icon-palette::before {
  content: "\\ea3b";
}

.icon-paper::before {
  content: "\\ea3c";
}

.icon-pencil::before {
  content: "\\ea3d";
}

.icon-pin::before {
  content: "\\ea3e";
}

.icon-planet::before {
  content: "\\ea3f";
}

.icon-puzzle-10::before {
  content: "\\ea40";
}

.icon-satisfied::before {
  content: "\\ea41";
}

.icon-scissors::before {
  content: "\\ea42";
}

.icon-send::before {
  content: "\\ea43";
}

.icon-settings-gear-63::before {
  content: "\\ea44";
}

.icon-settings::before {
  content: "\\ea45";
}

.icon-simple-add::before {
  content: "\\ea46";
}

.icon-simple-delete::before {
  content: "\\ea47";
}

.icon-simple-remove::before {
  content: "\\ea48";
}

.icon-single-02::before {
  content: "\\ea49";
}

.icon-single-copy-04::before {
  content: "\\ea4a";
}

.icon-sound-wave::before {
  content: "\\ea4b";
}

.icon-spaceship::before {
  content: "\\ea4c";
}

.icon-square-pin::before {
  content: "\\ea4d";
}

.icon-support-17::before {
  content: "\\ea4e";
}

.icon-tablet-2::before {
  content: "\\ea4f";
}

.icon-tag::before {
  content: "\\ea50";
}

.icon-tap-02::before {
  content: "\\ea51";
}

.icon-tie-bow::before {
  content: "\\ea52";
}

.icon-time-alarm::before {
  content: "\\ea53";
}

.icon-trash-simple::before {
  content: "\\ea54";
}

.icon-triangle-right-17::before {
  content: "\\ea55";
}

.icon-trophy::before {
  content: "\\ea56";
}

.icon-tv-2::before {
  content: "\\ea57";
}

.icon-upload::before {
  content: "\\ea58";
}

.icon-user-run::before {
  content: "\\ea59";
}

.icon-vector::before {
  content: "\\ea5a";
}

.icon-video-66::before {
  content: "\\ea5b";
}

.icon-volume-98::before {
  content: "\\ea5c";
}

.icon-wallet-43::before {
  content: "\\ea5d";
}

.icon-watch-time::before {
  content: "\\ea5e";
}

.icon-wifi::before {
  content: "\\ea5f";
}

.icon-world::before {
  content: "\\ea60";
}

.icon-zoom-split::before {
  content: "\\ea61";
}

.icon-refresh-01::before {
  content: "\\ea62";
}

.icon-refresh-02::before {
  content: "\\ea63";
}

.icon-shape-star::before {
  content: "\\ea64";
}

.icon-components::before {
  content: "\\ea65";
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/nucleo-icons.css"],"names":[],"mappings":"AAAA;;;;;;kCAMkC;;AAElC;EACE,qBAAqB;EACrB,4CAA+B;EAC/B,qPAAoM;EACpM,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B;EACE,qBAAqB;EACrB,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;oCAEoC;;AAEpC;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B;;0BAE0B;;AAE1B;EAGE,4CAA4C;AAC9C;;AAoBA;EACE;IAKE,uBAAuB;EACzB;EACA;IAKE,yBAAyB;EAC3B;AACF;;AAEA;;0BAE0B;;AAE1B;;0BAE0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* --------------------------------\n\nNucleo Outline Web Font - nucleoapp.com/\nLicense - nucleoapp.com/license/\nCreated using IcoMoon - icomoon.io\n\n-------------------------------- */\n\n@font-face {\n  font-family: 'Nucleo';\n  src: url('../fonts/nucleo.eot');\n  src: url('../fonts/nucleo.eot') format('embedded-opentype'), url('../fonts/nucleo.woff2') format('woff2'), url('../fonts/nucleo.woff') format('woff'), url('../fonts/nucleo.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/*------------------------\n\tbase class definition\n-------------------------*/\n\n.tim-icons {\n  display: inline-block;\n  font: normal normal normal 1em/1 'Nucleo';\n  vertical-align: middle;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.font-icon-detail {\n  text-align: center;\n  padding: 45px 0 30px;\n  border: 1px solid #e44cc4;\n  border-radius: .1875rem;\n  margin: 15px 0;\n  min-height: 168px;\n}\n\n.font-icon-detail i {\n  color: #FFFFFF;\n  font-size: 1.5em;\n}\n\n.font-icon-detail p {\n  color: #e44cc4 !important;\n  margin-top: 30px;\n  padding: 0 10px;\n  font-size: .7142em;\n}\n\n/*------------------------\n  change icon size\n-------------------------*/\n\n.tim-icons-sm {\n  font-size: 0.8em;\n}\n\n.tim-icons-lg {\n  font-size: 1.2em;\n}\n\n/* absolute units */\n\n.tim-icons-16 {\n  font-size: 16px;\n}\n\n.tim-icons-32 {\n  font-size: 32px;\n}\n\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n\n.tim-icons-bg-square,\n.tim-icons-bg-circle {\n  padding: 0.35em;\n}\n\n.tim-icons-bg-circle {\n  border-radius: 50%;\n}\n\n/*------------------------\n  list icons\n-------------------------*/\n\n/*------------------------\n  spinning icons\n-------------------------*/\n\n.tim-icons-is-spinning {\n  -webkit-animation: tim-icons-spin 2s infinite linear;\n  -moz-animation: tim-icons-spin 2s infinite linear;\n  animation: tim-icons-spin 2s infinite linear;\n}\n\n@-webkit-keyframes tim-icons-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes tim-icons-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@keyframes tim-icons-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n\n/*------------------------\n\ticons\n-------------------------*/\n\n.icon-alert-circle-exc::before {\n  content: \"\\ea02\";\n}\n\n.icon-align-center::before {\n  content: \"\\ea03\";\n}\n\n.icon-align-left-2::before {\n  content: \"\\ea04\";\n}\n\n.icon-app::before {\n  content: \"\\ea05\";\n}\n\n.icon-atom::before {\n  content: \"\\ea06\";\n}\n\n.icon-attach-87::before {\n  content: \"\\ea07\";\n}\n\n.icon-badge::before {\n  content: \"\\ea08\";\n}\n\n.icon-bag-16::before {\n  content: \"\\ea09\";\n}\n\n.icon-bank::before {\n  content: \"\\ea0a\";\n}\n\n.icon-basket-simple::before {\n  content: \"\\ea0b\";\n}\n\n.icon-bell-55::before {\n  content: \"\\ea0c\";\n}\n\n.icon-bold::before {\n  content: \"\\ea0d\";\n}\n\n.icon-book-bookmark::before {\n  content: \"\\ea0e\";\n}\n\n.icon-bulb-63::before {\n  content: \"\\ea0f\";\n}\n\n.icon-bullet-list-67::before {\n  content: \"\\ea10\";\n}\n\n.icon-bus-front-12::before {\n  content: \"\\ea11\";\n}\n\n.icon-button-pause::before {\n  content: \"\\ea12\";\n}\n\n.icon-button-power::before {\n  content: \"\\ea13\";\n}\n\n.icon-calendar-60::before {\n  content: \"\\ea14\";\n}\n\n.icon-camera-18::before {\n  content: \"\\ea15\";\n}\n\n.icon-caps-small::before {\n  content: \"\\ea16\";\n}\n\n.icon-cart::before {\n  content: \"\\ea17\";\n}\n\n.icon-chart-bar-32::before {\n  content: \"\\ea18\";\n}\n\n.icon-chart-pie-36::before {\n  content: \"\\ea19\";\n}\n\n.icon-chat-33::before {\n  content: \"\\ea1a\";\n}\n\n.icon-check-2::before {\n  content: \"\\ea1b\";\n}\n\n.icon-cloud-download-93::before {\n  content: \"\\ea1c\";\n}\n\n.icon-cloud-upload-94::before {\n  content: \"\\ea1d\";\n}\n\n.icon-coins::before {\n  content: \"\\ea1e\";\n}\n\n.icon-compass-05::before {\n  content: \"\\ea1f\";\n}\n\n.icon-controller::before {\n  content: \"\\ea20\";\n}\n\n.icon-credit-card::before {\n  content: \"\\ea21\";\n}\n\n.icon-delivery-fast::before {\n  content: \"\\ea22\";\n}\n\n.icon-double-left::before {\n  content: \"\\ea23\";\n}\n\n.icon-double-right::before {\n  content: \"\\ea24\";\n}\n\n.icon-email-85::before {\n  content: \"\\ea25\";\n}\n\n.icon-gift-2::before {\n  content: \"\\ea26\";\n}\n\n.icon-globe-2::before {\n  content: \"\\ea27\";\n}\n\n.icon-headphones::before {\n  content: \"\\ea28\";\n}\n\n.icon-heart-2::before {\n  content: \"\\ea29\";\n}\n\n.icon-html5::before {\n  content: \"\\ea2a\";\n}\n\n.icon-image-02::before {\n  content: \"\\ea2b\";\n}\n\n.icon-istanbul::before {\n  content: \"\\ea2c\";\n}\n\n.icon-key-25::before {\n  content: \"\\ea2d\";\n}\n\n.icon-laptop::before {\n  content: \"\\ea2e\";\n}\n\n.icon-light-3::before {\n  content: \"\\ea2f\";\n}\n\n.icon-link-72::before {\n  content: \"\\ea30\";\n}\n\n.icon-lock-circle::before {\n  content: \"\\ea31\";\n}\n\n.icon-map-big::before {\n  content: \"\\ea32\";\n}\n\n.icon-minimal-down::before {\n  content: \"\\ea33\";\n}\n\n.icon-minimal-left::before {\n  content: \"\\ea34\";\n}\n\n.icon-minimal-right::before {\n  content: \"\\ea35\";\n}\n\n.icon-minimal-up::before {\n  content: \"\\ea36\";\n}\n\n.icon-mobile::before {\n  content: \"\\ea37\";\n}\n\n.icon-molecule-40::before {\n  content: \"\\ea38\";\n}\n\n.icon-money-coins::before {\n  content: \"\\ea39\";\n}\n\n.icon-notes::before {\n  content: \"\\ea3a\";\n}\n\n.icon-palette::before {\n  content: \"\\ea3b\";\n}\n\n.icon-paper::before {\n  content: \"\\ea3c\";\n}\n\n.icon-pencil::before {\n  content: \"\\ea3d\";\n}\n\n.icon-pin::before {\n  content: \"\\ea3e\";\n}\n\n.icon-planet::before {\n  content: \"\\ea3f\";\n}\n\n.icon-puzzle-10::before {\n  content: \"\\ea40\";\n}\n\n.icon-satisfied::before {\n  content: \"\\ea41\";\n}\n\n.icon-scissors::before {\n  content: \"\\ea42\";\n}\n\n.icon-send::before {\n  content: \"\\ea43\";\n}\n\n.icon-settings-gear-63::before {\n  content: \"\\ea44\";\n}\n\n.icon-settings::before {\n  content: \"\\ea45\";\n}\n\n.icon-simple-add::before {\n  content: \"\\ea46\";\n}\n\n.icon-simple-delete::before {\n  content: \"\\ea47\";\n}\n\n.icon-simple-remove::before {\n  content: \"\\ea48\";\n}\n\n.icon-single-02::before {\n  content: \"\\ea49\";\n}\n\n.icon-single-copy-04::before {\n  content: \"\\ea4a\";\n}\n\n.icon-sound-wave::before {\n  content: \"\\ea4b\";\n}\n\n.icon-spaceship::before {\n  content: \"\\ea4c\";\n}\n\n.icon-square-pin::before {\n  content: \"\\ea4d\";\n}\n\n.icon-support-17::before {\n  content: \"\\ea4e\";\n}\n\n.icon-tablet-2::before {\n  content: \"\\ea4f\";\n}\n\n.icon-tag::before {\n  content: \"\\ea50\";\n}\n\n.icon-tap-02::before {\n  content: \"\\ea51\";\n}\n\n.icon-tie-bow::before {\n  content: \"\\ea52\";\n}\n\n.icon-time-alarm::before {\n  content: \"\\ea53\";\n}\n\n.icon-trash-simple::before {\n  content: \"\\ea54\";\n}\n\n.icon-triangle-right-17::before {\n  content: \"\\ea55\";\n}\n\n.icon-trophy::before {\n  content: \"\\ea56\";\n}\n\n.icon-tv-2::before {\n  content: \"\\ea57\";\n}\n\n.icon-upload::before {\n  content: \"\\ea58\";\n}\n\n.icon-user-run::before {\n  content: \"\\ea59\";\n}\n\n.icon-vector::before {\n  content: \"\\ea5a\";\n}\n\n.icon-video-66::before {\n  content: \"\\ea5b\";\n}\n\n.icon-volume-98::before {\n  content: \"\\ea5c\";\n}\n\n.icon-wallet-43::before {\n  content: \"\\ea5d\";\n}\n\n.icon-watch-time::before {\n  content: \"\\ea5e\";\n}\n\n.icon-wifi::before {\n  content: \"\\ea5f\";\n}\n\n.icon-world::before {\n  content: \"\\ea60\";\n}\n\n.icon-zoom-split::before {\n  content: \"\\ea61\";\n}\n\n.icon-refresh-01::before {\n  content: \"\\ea62\";\n}\n\n.icon-refresh-02::before {\n  content: \"\\ea63\";\n}\n\n.icon-shape-star::before {\n  content: \"\\ea64\";\n}\n\n.icon-components::before {\n  content: \"\\ea65\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
